import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log';
import type { aggBacklogDataQuery$data } from '@atlassian/jira-relay/src/__generated__/aggBacklogDataQuery.graphql';
import type { PrefetchedDataGql } from '@atlassian/jira-software-backlog-load-agility-graphql-data/src/types';
import type {
	FieldConfigs,
	StoreFieldsActions,
} from '../../common/hooks/use-store-fields/types.tsx';
import { isBacklogWithRelayEnabled } from '../../feature-flags';
import loadAgilityGraphqlData from '../../services/load-agility-graphql-data';
import {
	type LoadAppDataAction,
	LOAD_APP_DATA_REQUEST,
	loadAppDataFailure,
	setAppData,
} from '../../state/actions/app';
import {
	getBaseUrl,
	getIsCompanyManaged,
	getRapidViewId,
	getStoryPointFieldId,
} from '../../state/selectors/app';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types';

export const fetchData = (params: {
	store: MiddlewareAPI;
	prefetchedData?: PrefetchedDataGql | null;
	prefetchedAggData?: aggBacklogDataQuery$data | null;
	storeFieldsActions?: StoreFieldsActions | null;
	fetchDataFromAGG?: () => Promise<aggBacklogDataQuery$data>;
}) => {
	const {
		store,
		prefetchedData = null,
		prefetchedAggData,
		fetchDataFromAGG,
		storeFieldsActions,
	} = params;
	const state = store.getState();
	const baseUrl = getBaseUrl(state);
	const boardId = getRapidViewId(state);
	const isCompanyManaged = getIsCompanyManaged(state);
	const storyPointFieldId = getStoryPointFieldId(state);
	const fieldConfigs: FieldConfigs = { storyPointFieldId };

	return loadAgilityGraphqlData({
		baseUrl,
		boardId,
		fieldConfigs,
		prefetchedData,
		prefetchedAggData,
		storeFieldsActions,
		fetchDataFromAGG,
		isCompanyManaged,
	})
		.map(setAppData)
		.catch((restError) => {
			const message =
				isBacklogWithRelayEnabled() && fetchDataFromAGG
					? 'Failed to load graphql data from AGG'
					: 'Failed to load graphql data';
			log.safeErrorWithoutCustomerData(
				'backlog.load-agility-graphql-data.failure',
				message,
				restError,
			);
			return Observable.of(loadAppDataFailure());
		});
};

export const loadAgilityGraphqlDataEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(LOAD_APP_DATA_REQUEST).flatMap((action: LoadAppDataAction) =>
		fetchData({
			store,
			prefetchedData: action.payload.prefetchedData,
			prefetchedAggData: action.payload.prefetchedAggData,
			storeFieldsActions: action.payload.storeFieldsActions,
		}),
	);
